import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cog } from "lucide-react";

const integrations = [
  {
    name: "Meta",
    description: "Connect your Facebook account for Instagram messaging and comments",
    path: "/settings/integrations/meta",
  },
  {
    name: "Instagram",
    description: "Connect your Instagram account",
    path: "/settings/integrations/instagram",
  },
  {
    name: "Stripe",
    description: "Connect your Stripe account to accept payments",
    path: "/settings/integrations/stripe",
  },
  {
    name: "Shopify",
    description: "Connect your Shopify store to sync products and orders",
    path: "/settings/integrations/shopify",
  },
  {
    name: "Kunaki",
    description: "Connect your Kunaki account to manage print-on-demand products",
    path: "/settings/integrations/kunaki",
  },
  {
    name: "EasyShip",
    description: "Shipping labels and rates",
    path: "/settings/integrations/easyship",
  },
  {
    name: "MailerLite",
    description: "Connect your MailerLite account to manage email subscribers",
    path: "/settings/integrations/mailerlite",
  },
  {
    name: "Brevo",
    description: "Connect your Brevo account to manage email subscribers and transactional email",
    path: "/settings/integrations/brevo",
  },
  {
    name: "Laylo",
    description: "Connect your Laylo account for drop notifications and fan engagement",
    path: "/settings/integrations/laylo",
  },
  {
    name: "Beehiiv",
    description: "Connect your Beehiiv account to add newsletter subscribers from flows",
    path: "/settings/integrations/beehiiv",
  },
  {
    name: "Manychat",
    description: "Connect your Manychat account to update subscribers and apply tags",
    path: "/settings/integrations/manychat",
  },
  {
    name: "API Keys",
    description: "Create API keys to access Fanrank programmatically",
    path: "/settings/integrations/api-keys",
  },
];

export function SettingsIntegrations() {
  return (
    <div className="max-w-2xl space-y-6">
      <div className="space-y-4">
        {integrations.map((integration) => (
          <div key={integration.path} className="border rounded-lg p-4">
            <div className="flex items-center justify-between gap-4">
              <div className="space-y-1 flex-1 min-w-0">
                <h3 className="text-lg font-semibold">{integration.name}</h3>
                <p className="text-sm text-muted-foreground">{integration.description}</p>
              </div>
              <Button
                variant="outline"
                size="icon"
                asChild
                aria-label={`${integration.name} integration settings`}
              >
                <Link to={integration.path}>
                  <Cog className="h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
